exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fa-info-circle[data-v-17f4bdd0]{\n    padding-left: 12px;\n    opacity: 0.5;\n}\n", ""]);

// exports
